(ns ui.view.counterparty-diligence.responder-form.card)

(defn view
  [props-or-first-child & rest-children]
  (let [props (if (map? props-or-first-child)
                props-or-first-child
                {})
        children (if (map? props-or-first-child)
                   rest-children
                   (cons props-or-first-child rest-children))
        title (:title props)]
    [:div
     {:class "rounded border bg-base-light"}
     (when title
       [:div
        {:class "p-3 border border-t-0 border-x-0"}
        [:p
         {:class "font-semibold "}
         title]])

     (into [:div {:class "p-5"}] children)]))
